import Register from './register.vue'
export default Register